export let bannerDetailsVOD = [
    {   "text": "Select your favorite <span>shows today!</span>",
        "image": "./img/slider/slide-one.jpg",
        "shortText": "Mobio TV VOD",
    },
      { "text": "",
        "image": "./img/slider/vod-1.jpeg",
        "shortText": "The Broken",
        "video":{
            "duration": "Watch Now",
            "id": 204,
            "name": "The Broken",
            "preview": "./img/movies/hollywood-blockbusters/the-broken.jpeg",
            "desc": "A woman is thrust into a world where everything is subtly unfamiliar in this edgy thriller from writer and director Sean Ellis. Gina McVay (Lena Headey) is a radiologist who is enjoying dinner one evening with her family and her boyfriend Stefan (Melvil Poupaud) when a mirror shatters for no apparent reason. After a few moments, no one thinks much of it, but the next day Gina is leaving work and she sees something even more troubling -- a woman who looks just like her, driving a car identical to her own. Curious, Gina sneaks into the doppelganger's apartment and sees a photo of herself and her father in the hallway. Seriously rattled, Gina runs out and drives away, only to get in an accident that lands her in the hospital. After she's released, Gina asks Stefan if she can stay with him, but while he looks the same, his personality and behavior are quite different from the way she remembers him, and she begins having vivid nightmares which become all the more terrifying when the same horrific images begin popping up in her waking hours. The Broken received its American premiere at the 2008 Sundance Film Festival.",
            "videoUrl": "",
            "subCategory":[]
        }

    },
    { "text": "",
        "image": "./img/slider/vod-2.jpeg",
        "shortText": "Dancing with the Stars",
        "video":{
            "duration": 1,
            "id": 60,
            "name": "Heik Men3'ani",
            "preview": "./img/movies/arabic-entertainment/Heik-Men3'ani.jpg",
            "desc": "MTV redefines singing competitions with this new show featuring contestants trying to remember the lyrics to popular songs through various games. Hosted by Maya Diab.",
            "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3ajabtini.mp4",
            "subCategory":
                [
                    // {
                    //     "id": 61,
                    //     "name": "3ajabtini",
                    //     "desc": "",
                    //     "preview": " ./img/thumbnails/heik-men3-ani/3ajabtini.jpg",
                    //     "videoUrl": "",
                    //     "duration": 1,
                    // },
                    {
                        "id": 62,
                        "name": "3allem Waladak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3allem_Waladak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3allem_Waladak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 63,
                        "name": "3ataki 3omro",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3ataki_3omro.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3ataki_3omro.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 64,
                        "name": "3azzetni El Deni",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3azzetni_El_Deni.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3azzetni_El_Deni.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 65,
                        "name": "3youn Bahiyya",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3youn_Bahiyya.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3youn_Bahiyya.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 66,
                        "name": "7abayt 3younak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7abayt_3younak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7abayt_3younak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 67,
                        "name": "7aji Matar",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7aji_Matar.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7aji_Matar.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 68,
                        "name": "7asibak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7asibak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7asibak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 69,
                        "name": "7ekyou 3enayk",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7ekyou_3enayk.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7ekyou_3enayk.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 70,
                        "name": "Ahla Gharam",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ahla_Gharam.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ahla_Gharam.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 71,
                        "name": "Ahla Lebnaniye",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ahla_Lebnaniye.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ahla_Lebnaniye.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 72,
                        "name": "Ahlik Ma Baddoun Yani",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ahlik_Ma_Baddoun_Yani.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ahlik_Ma_Baddoun_Yani.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 73,
                        "name": "Al Kamar Al Sina3i",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/al_kamar_al_sina3i.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/al_kamar_al_sina3i.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 74,
                        "name": "Alawa",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Alawa.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Alawa.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 75,
                        "name": "Allah Ma3ak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Allah_Ma3ak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Allah_Ma3ak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 76,
                        "name": "Allah Shou B7ebak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Allah_Shou_B7ebak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Allah_Shou_B7ebak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 77,
                        "name": "Ashouf Fik Youm",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ashouf_Fik_Youm.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ashouf_Fik_Youm.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 78,
                        "name": "Assem Shar2i Baladi",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Assem_Shar2i_Baladi.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Assem_Shar2i_Baladi.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 79,
                        "name": "Ba7ebak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ba7ebak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ba7ebak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 80,
                        "name": "Bawastik",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bawastik.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bawastik.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 81,
                        "name": "Bez3al Menak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bez3al_Menak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bez3al_Menak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 82,
                        "name": "Bfakker Fik",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bfakker_Fik.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bfakker_Fik.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 83,
                        "name": "Bourdayik Ya Bordana",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bourdayik_Ya_Bordana.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bourdayik_Ya_Bordana.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 84,
                        "name": "Bto2mor 3al Rass w 3al 3ayn",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/bto2mor_3al_rass_w_3al_3ayn.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/bto2mor_3al_rass_w_3al_3ayn.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 85,
                        "name": "Byeb3at Allah",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Byeb3at_Allah.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Byeb3at_Allah.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 86,
                        "name": "Byeb3at Allah Kbir",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Byeb3at_Allah_Kbir.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Byeb3at_Allah_Kbir.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 87,
                        "name": "Chou Ba3melik",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/chou_ba3melik.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/chou_ba3melik.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 88,
                        "name": "Dakhel El Ghannouj",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Dakhel_El_Ghannouj.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Dakhel_El_Ghannouj.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 89,
                        "name": "Ento Al Banat",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ento_Al_Banat.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ento_Al_Banat.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 90,
                        "name": "Enzel Ya Gamil",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Enzel_Ya_Gamil.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Enzel_Ya_Gamil.mp4",
                        "duration": 1,
                    },

                ]
        },

    },
    { "text": "",
        "image": "./img/slider/vod-3.jpeg",
        "shortText": "Maya Daib",
        "video":{
            "duration": 1,
            "id": 112,
            "name": "Dancing with the Stars",
            "preview": "./img/movies/arabic-entertainment/dancing-with-the-star.jpg",
            "desc": "Enjoy even more sizzling salsas, sambas and spray-tans as a brand-new cast vies for the coveted Mirror ball Trophy on Dancing with the Stars returns for Season 25! Tom Bergeron and Erin Andrews are back to guide us through this exciting new season along with your favourite judges. Of course, it's still all about the fans who ultimately help determine which teams make the cut each week with their votes during the biggest dance party on the planet!",
            "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_chacha-amina-achraf.mp4",
            "subCategory":
                [
                    // {
                    //     "id": 113,
                    //     "name": "DWTS - Chacha Amina Achraf",
                    //     "desc": "",
                    //     "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-amina-achraf.jpg",
                    //     "videoUrl": "",
                    //     "duration": 1,
                    // },
                    {
                        "id": 114,
                        "name": "DWTS - Chacha Dalida Khalil",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-dalida-khalil.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_chacha-dalida-khalil.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 115,
                        "name": "DWTS - Chacha Jane Konsol",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-jane-konsol.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_chacha-jane-konsol.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 116,
                        "name": "DWTS - Chacha Jean Paul Bitar",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-jean-paul-bitar.jpg",
                        "videoUrl": "",
                        "duration": 1,
                    },
                    {
                        "id": 117,
                        "name": "DWTS - Foxtrot Anthony Touma",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_foxtrot-anthony-touma.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_foxtrot-anthony-touma.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 118,
                        "name": "DWTS - Foxtrot Mohamed Attieh",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_foxtrot-mohamed-attieh.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_foxtrot-mohamed-attieh.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 119,
                        "name": "DWTS - Salsa Anthony Touma",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-anthony-touma.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_salsa-anthony-touma.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 120,
                        "name": "DWTS - Salsa Mohamed Attieh",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-mohamed-attieh.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_salsa-mohamed-attieh.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 121,
                        "name": "DWTS - Salsa Rony Fahed",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-rony-fahed.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_salsa-rony-fahed.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 122,
                        "name": "DWTS - Tango Carmen Lebbos",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-carmen-lebbos.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-carmen-lebbos.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 123,
                        "name": "DWTS - Tango Leila Ben Khalifa",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-leila-ben-khalifa.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-leila-ben-khalifa.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 124,
                        "name": "DWTS - Tango Reine Achkar",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-reine-achkar.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-reine-achkar.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 125,
                        "name": "DWTS - Tango Rima-Fakih",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-rima-fakih.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-rima-fakih.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 126,
                        "name": "DWTS - Waltz Gabriel Yammine",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_waltz-gabriel-yammine.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_waltz-gabriel-yammine.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 127,
                        "name": "DWTS - Waltz Ibrahim Said",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_waltz-ibrahim-said.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_waltz-ibrahim-said.mp4",
                        "duration": 1,
                    },
                ]
        },
    },
    { "text": "",
        "image": "./img/slider/vod-4.jpeg",
        "shortText": "Inside the Milky Way",
        "video": {
            "duration": 21334,
            "id": 17,
            "name": "Inside the Milky Way",
            "preview": "./img/movies/documentaries/Inside-the-Milky-Way.jpg",
            "desc": "نظامنا الشمسي يقع على مشارف مدينة سماوية واسعة، مجتمع ضخم من النجوم المرتبطة مع بعضها بقوانين الجاذبية فيما بعرف بمجرة درب الحليب. في يومنا هذا، يحاول علماء الفلك بالتعاون مع بعضهم البعض تفكيك الأحجية التي ستسمح لهم برؤية مجرتنا بطريقة جديدة ومثيرة للاهتمام تسمح بنا بأن نأخذ كوكبنا \"الأرض\" في رحلة مذهلة في مجاهل الفضاء الخارجي والزمن، كي نرى كيف تبدو الأحياء الأخرى المختلفة من مدينتنا النجمية الواسعة لو قمنا بزيارتها عن قرب!؟مصور ومعد باحتراف وأناقة، ومن خلال تلك المقابلات الودية مع العلماء الذين سيكشفون لنا متعة اكتشاف المفاهيم العلمية، سيروي لنا هذا العمل المتميز قصة مجرتنا بطريقة واضحة وسلسة وفوق كل ذلك ممتعة ومثيرة، فيما يلقي لنا نظرة ثاقبة على كيف تكونت -هي وكل ما فيها - مجرة درب الحليب.",
            "videoUrl": "",
            "subCategory":[]
        }
    }
];

export let bannerDetailsVODMobile = [
    {   "text": "Select your favorite <span>shows today!</span>",
        "image": './img/slider/mobile/mobile-slide-one.jpeg',
        "shortText": "Mobio TV VOD",
    },
    { "text": "",
        "image": "./img/slider/mobile/mobile-vod-1.jpeg",
        "shortText": "The Broken",
        "video":{
            "duration": "Watch Now",
            "id": 204,
            "name": "The Broken",
            "preview": "./img/movies/hollywood-blockbusters/the-broken.jpeg",
            "desc": "A woman is thrust into a world where everything is subtly unfamiliar in this edgy thriller from writer and director Sean Ellis. Gina McVay (Lena Headey) is a radiologist who is enjoying dinner one evening with her family and her boyfriend Stefan (Melvil Poupaud) when a mirror shatters for no apparent reason. After a few moments, no one thinks much of it, but the next day Gina is leaving work and she sees something even more troubling -- a woman who looks just like her, driving a car identical to her own. Curious, Gina sneaks into the doppelganger's apartment and sees a photo of herself and her father in the hallway. Seriously rattled, Gina runs out and drives away, only to get in an accident that lands her in the hospital. After she's released, Gina asks Stefan if she can stay with him, but while he looks the same, his personality and behavior are quite different from the way she remembers him, and she begins having vivid nightmares which become all the more terrifying when the same horrific images begin popping up in her waking hours. The Broken received its American premiere at the 2008 Sundance Film Festival.",
            "videoUrl": "",
            "subCategory":[]
        }

    },
    { "text": "",
        "image": "./img/slider/mobile/mobile-vod-2.jpeg",
        "shortText": "Dancing with the Stars",
        "video":{
            "duration": 1,
            "id": 60,
            "name": "Heik Men3'ani",
            "preview": "./img/movies/arabic-entertainment/Heik-Men3'ani.jpg",
            "desc": "MTV redefines singing competitions with this new show featuring contestants trying to remember the lyrics to popular songs through various games. Hosted by Maya Diab.",
            "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3ajabtini.mp4",
            "subCategory":
                [
                    // {
                    //     "id": 61,
                    //     "name": "3ajabtini",
                    //     "desc": "",
                    //     "preview": " ./img/thumbnails/heik-men3-ani/3ajabtini.jpg",
                    //     "videoUrl": "",
                    //     "duration": 1,
                    // },
                    {
                        "id": 62,
                        "name": "3allem Waladak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3allem_Waladak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3allem_Waladak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 63,
                        "name": "3ataki 3omro",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3ataki_3omro.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3ataki_3omro.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 64,
                        "name": "3azzetni El Deni",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3azzetni_El_Deni.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3azzetni_El_Deni.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 65,
                        "name": "3youn Bahiyya",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/3youn_Bahiyya.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/3youn_Bahiyya.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 66,
                        "name": "7abayt 3younak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7abayt_3younak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7abayt_3younak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 67,
                        "name": "7aji Matar",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7aji_Matar.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7aji_Matar.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 68,
                        "name": "7asibak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7asibak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7asibak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 69,
                        "name": "7ekyou 3enayk",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/7ekyou_3enayk.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/7ekyou_3enayk.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 70,
                        "name": "Ahla Gharam",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ahla_Gharam.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ahla_Gharam.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 71,
                        "name": "Ahla Lebnaniye",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ahla_Lebnaniye.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ahla_Lebnaniye.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 72,
                        "name": "Ahlik Ma Baddoun Yani",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ahlik_Ma_Baddoun_Yani.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ahlik_Ma_Baddoun_Yani.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 73,
                        "name": "Al Kamar Al Sina3i",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/al_kamar_al_sina3i.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/al_kamar_al_sina3i.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 74,
                        "name": "Alawa",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Alawa.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Alawa.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 75,
                        "name": "Allah Ma3ak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Allah_Ma3ak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Allah_Ma3ak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 76,
                        "name": "Allah Shou B7ebak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Allah_Shou_B7ebak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Allah_Shou_B7ebak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 77,
                        "name": "Ashouf Fik Youm",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ashouf_Fik_Youm.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ashouf_Fik_Youm.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 78,
                        "name": "Assem Shar2i Baladi",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Assem_Shar2i_Baladi.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Assem_Shar2i_Baladi.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 79,
                        "name": "Ba7ebak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ba7ebak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ba7ebak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 80,
                        "name": "Bawastik",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bawastik.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bawastik.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 81,
                        "name": "Bez3al Menak",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bez3al_Menak.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bez3al_Menak.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 82,
                        "name": "Bfakker Fik",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bfakker_Fik.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bfakker_Fik.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 83,
                        "name": "Bourdayik Ya Bordana",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Bourdayik_Ya_Bordana.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Bourdayik_Ya_Bordana.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 84,
                        "name": "Bto2mor 3al Rass w 3al 3ayn",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/bto2mor_3al_rass_w_3al_3ayn.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/bto2mor_3al_rass_w_3al_3ayn.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 85,
                        "name": "Byeb3at Allah",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Byeb3at_Allah.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Byeb3at_Allah.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 86,
                        "name": "Byeb3at Allah Kbir",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Byeb3at_Allah_Kbir.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Byeb3at_Allah_Kbir.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 87,
                        "name": "Chou Ba3melik",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/chou_ba3melik.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/chou_ba3melik.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 88,
                        "name": "Dakhel El Ghannouj",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Dakhel_El_Ghannouj.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Dakhel_El_Ghannouj.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 89,
                        "name": "Ento Al Banat",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Ento_Al_Banat.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Ento_Al_Banat.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 90,
                        "name": "Enzel Ya Gamil",
                        "desc": "",
                        "preview": " ./img/thumbnails/heik-men3-ani/Enzel_Ya_Gamil.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/heikmenghani/Enzel_Ya_Gamil.mp4",
                        "duration": 1,
                    },

                ]
        },

    },
    { "text": "",
        "image": "./img/slider/mobile/mobile-vod-3.jpeg",
        "shortText": "Maya Daib",
        "video":{
            "duration": 1,
            "id": 112,
            "name": "Dancing with the Stars",
            "preview": "./img/movies/arabic-entertainment/dancing-with-the-star.jpg",
            "desc": "Enjoy even more sizzling salsas, sambas and spray-tans as a brand-new cast vies for the coveted Mirror ball Trophy on Dancing with the Stars returns for Season 25! Tom Bergeron and Erin Andrews are back to guide us through this exciting new season along with your favourite judges. Of course, it's still all about the fans who ultimately help determine which teams make the cut each week with their votes during the biggest dance party on the planet!",
            "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_chacha-amina-achraf.mp4",
            "subCategory":
                [
                    // {
                    //     "id": 113,
                    //     "name": "DWTS - Chacha Amina Achraf",
                    //     "desc": "",
                    //     "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-amina-achraf.jpg",
                    //     "videoUrl": "",
                    //     "duration": 1,
                    // },
                    {
                        "id": 114,
                        "name": "DWTS - Chacha Dalida Khalil",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-dalida-khalil.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_chacha-dalida-khalil.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 115,
                        "name": "DWTS - Chacha Jane Konsol",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-jane-konsol.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_chacha-jane-konsol.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 116,
                        "name": "DWTS - Chacha Jean Paul Bitar",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-jean-paul-bitar.jpg",
                        "videoUrl": "",
                        "duration": 1,
                    },
                    {
                        "id": 117,
                        "name": "DWTS - Foxtrot Anthony Touma",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_foxtrot-anthony-touma.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_foxtrot-anthony-touma.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 118,
                        "name": "DWTS - Foxtrot Mohamed Attieh",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_foxtrot-mohamed-attieh.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_foxtrot-mohamed-attieh.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 119,
                        "name": "DWTS - Salsa Anthony Touma",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-anthony-touma.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_salsa-anthony-touma.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 120,
                        "name": "DWTS - Salsa Mohamed Attieh",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-mohamed-attieh.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_salsa-mohamed-attieh.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 121,
                        "name": "DWTS - Salsa Rony Fahed",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-rony-fahed.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_salsa-rony-fahed.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 122,
                        "name": "DWTS - Tango Carmen Lebbos",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-carmen-lebbos.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-carmen-lebbos.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 123,
                        "name": "DWTS - Tango Leila Ben Khalifa",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-leila-ben-khalifa.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-leila-ben-khalifa.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 124,
                        "name": "DWTS - Tango Reine Achkar",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-reine-achkar.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-reine-achkar.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 125,
                        "name": "DWTS - Tango Rima-Fakih",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_tango-rima-fakih.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_tango-rima-fakih.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 126,
                        "name": "DWTS - Waltz Gabriel Yammine",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_waltz-gabriel-yammine.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_waltz-gabriel-yammine.mp4",
                        "duration": 1,
                    },
                    {
                        "id": 127,
                        "name": "DWTS - Waltz Ibrahim Said",
                        "desc": "",
                        "preview": " ./img/thumbnails/dwts/dwts_s3_waltz-ibrahim-said.jpg",
                        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Videos/Dancing+With+The+Star/dwts_s3_waltz-ibrahim-said.mp4",
                        "duration": 1,
                    },
                ]
        },

    },
    { "text": "",
        "image": "./img/slider/mobile/mobile-vod-4.jpeg",
        "shortText": "Inside the Milky Way",
       "video": {
        "duration": 21334,
        "id": 17,
        "name": "Inside the Milky Way",
        "preview": "./img/movies/documentaries/Inside-the-Milky-Way.jpg",
        "desc": "نظامنا الشمسي يقع على مشارف مدينة سماوية واسعة، مجتمع ضخم من النجوم المرتبطة مع بعضها بقوانين الجاذبية فيما بعرف بمجرة درب الحليب. في يومنا هذا، يحاول علماء الفلك بالتعاون مع بعضهم البعض تفكيك الأحجية التي ستسمح لهم برؤية مجرتنا بطريقة جديدة ومثيرة للاهتمام تسمح بنا بأن نأخذ كوكبنا \"الأرض\" في رحلة مذهلة في مجاهل الفضاء الخارجي والزمن، كي نرى كيف تبدو الأحياء الأخرى المختلفة من مدينتنا النجمية الواسعة لو قمنا بزيارتها عن قرب!؟مصور ومعد باحتراف وأناقة، ومن خلال تلك المقابلات الودية مع العلماء الذين سيكشفون لنا متعة اكتشاف المفاهيم العلمية، سيروي لنا هذا العمل المتميز قصة مجرتنا بطريقة واضحة وسلسة وفوق كل ذلك ممتعة ومثيرة، فيما يلقي لنا نظرة ثاقبة على كيف تكونت -هي وكل ما فيها - مجرة درب الحليب.",
        "videoUrl": "",
        "subCategory":[]
}}
];



// WEBPACK FOOTER //
// ./src/constants/bannerDetailvod.js